import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20cff376"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "vacuum-dashboard"
};
const _hoisted_2 = {
  class: "dashboard-main"
};
const _hoisted_3 = {
  class: "dashboard-column dashboard-column--left"
};
const _hoisted_4 = {
  class: "dashboard-card dashboard-card--vacuum"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "真空度参数监控")], -1));
const _hoisted_6 = {
  class: "vacuum-metrics"
};
const _hoisted_7 = {
  class: "vacuum-metric__top"
};
const _hoisted_8 = {
  class: "metric-name"
};
const _hoisted_9 = {
  class: "metric-state"
};
const _hoisted_10 = {
  class: "vacuum-metric__value"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pa", -1));
const _hoisted_12 = {
  class: "vacuum-metric__delta"
};
const _hoisted_13 = {
  class: "vacuum-chart"
};
const _hoisted_14 = {
  class: "dashboard-card dashboard-card--energy"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "能耗与辅助参数")], -1));
const _hoisted_16 = {
  class: "energy-highlight-grid"
};
const _hoisted_17 = {
  class: "energy-highlight__label"
};
const _hoisted_18 = {
  class: "energy-highlight__value"
};
const _hoisted_19 = {
  class: "energy-highlight__unit"
};
const _hoisted_20 = {
  class: "energy-aux-grid"
};
const _hoisted_21 = {
  class: "aux-metric__label"
};
const _hoisted_22 = {
  class: "aux-metric__value"
};
const _hoisted_23 = {
  class: "dashboard-card dashboard-card--runtime"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "系统时间统计")], -1));
const _hoisted_25 = {
  class: "runtime-list"
};
const _hoisted_26 = {
  class: "runtime-row__copy"
};
const _hoisted_27 = {
  class: "runtime-row__label"
};
const _hoisted_28 = {
  class: "runtime-row__note"
};
const _hoisted_29 = {
  class: "runtime-row__value"
};
const _hoisted_30 = {
  class: "dashboard-center"
};
const _hoisted_31 = {
  class: "dashboard-center__shell"
};
const _hoisted_32 = {
  class: "model-stage model-stage--plain"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "stage-menu",
  "aria-label": "主界面功能菜单"
};
const _hoisted_35 = ["aria-current"];
const _hoisted_36 = {
  class: "stage-menu__index"
};
const _hoisted_37 = {
  class: "stage-menu__label"
};
const _hoisted_38 = {
  class: "stage-menu__caption"
};
const _hoisted_39 = {
  class: "dashboard-column dashboard-column--right"
};
const _hoisted_40 = {
  class: "dashboard-card dashboard-card--video"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "仓内监控画面")], -1));
const _hoisted_42 = {
  class: "video-shell"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  class: "dashboard-card dashboard-card--status"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "设备监控状态")], -1));
const _hoisted_46 = {
  class: "status-list"
};
const _hoisted_47 = {
  class: "status-row__main"
};
const _hoisted_48 = {
  class: "status-row__name"
};
const _hoisted_49 = {
  class: "status-row__desc"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-row__badge"
}, "正常", -1));
const _hoisted_51 = {
  class: "dashboard-card dashboard-card--alarm"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "section-head"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "section-title"
}, "告警信息模块")], -1));
const _hoisted_53 = {
  class: "alarm-list"
};
const _hoisted_54 = {
  class: "alarm-row__time"
};
const _hoisted_55 = {
  class: "alarm-row__content"
};
const _hoisted_56 = {
  class: "alarm-row__title"
};
const _hoisted_57 = {
  class: "alarm-row__desc"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "alarm-row__badge"
}, "已处理", -1));
import { computed, onMounted, onUnmounted, ref } from "vue";
import * as echarts from "echarts";
import Head from "@/components/Head/index.vue";
import Map from "@/components/Map/index.vue";
import modelImage from "@/assets/resource/model.png";
import chamberVideo from "@/assets/resource/推力器点火测试.mp4";
const chartPointCount = 30;
const simulationStepSeconds = 3;
const chartLabelInterval = 5;
export default {
  __name: 'index',
  setup(__props) {
    const stageMenuItems = [{
      code: "01",
      label: "主控界面",
      caption: "CONTROL"
    }, {
      code: "02",
      label: "历史数据",
      caption: "HISTORY"
    }, {
      code: "03",
      label: "趋势曲线",
      caption: "TREND"
    }, {
      code: "04",
      label: "报警信息",
      caption: "ALARM"
    }, {
      code: "05",
      label: "参数设置",
      caption: "PARAM"
    }, {
      code: "06",
      label: "操作日志",
      caption: "LOGBOOK"
    }, {
      code: "07",
      label: "用户管理",
      caption: "USERS"
    }];
    const chamberDefinitions = [{
      key: "mainCabin1",
      name: "主舱1",
      color: "#63f7ff",
      softColor: "rgba(99, 247, 255, 0.14)",
      base: 0.78,
      variance: 0.05,
      min: 0.52,
      max: 1.08
    }, {
      key: "mainCabin2",
      name: "主舱2",
      color: "#50a4ff",
      softColor: "rgba(80, 164, 255, 0.14)",
      base: 0.86,
      variance: 0.06,
      min: 0.58,
      max: 1.14
    }, {
      key: "testCabin1",
      name: "测舱1",
      color: "#7effc1",
      softColor: "rgba(126, 255, 193, 0.14)",
      base: 0.68,
      variance: 0.04,
      min: 0.41,
      max: 0.98
    }, {
      key: "testCabin2",
      name: "测舱2",
      color: "#ffb86a",
      softColor: "rgba(255, 184, 106, 0.14)",
      base: 0.74,
      variance: 0.05,
      min: 0.45,
      max: 1.02
    }];
    const chamberSeries = ref(createInitialSeries());
    const timeline = ref(createInitialTimeline(chartPointCount, simulationStepSeconds));
    const energyState = ref({
      power: 1284.6,
      water: 426.2,
      air: 98.4,
      mainReturnTemp: 18.6,
      mainReturnFlow: 42.5,
      mainSupplyPressure: 0.62,
      shaftReturnTemp: 20.1,
      shaftReturnFlow: 39.4,
      shaftReturnPressure: 0.58
    });
    const runtimeState = ref({
      totalSeconds: 315624,
      axisGasSeconds: 31872
    });
    const deviceStatuses = [{
      name: "主舱系统",
      description: "温控稳定"
    }, {
      name: "侧舱1系统",
      description: "抽气正常"
    }, {
      name: "侧舱2系统",
      description: "链路在线"
    }, {
      name: "侧舱3系统",
      description: "阀组同步"
    }, {
      name: "真空抽气系统",
      description: "抽速平滑"
    }, {
      name: "控温系统",
      description: "供回水平衡"
    }, {
      name: "辅助系统",
      description: "联锁正常"
    }];
    const processedAlarms = [{
      time: "11:06:18",
      title: "主舱供气压力短时波动",
      desc: "压力恢复正常，联锁已复位"
    }, {
      time: "10:42:07",
      title: "轴舱回水温度偏高",
      desc: "控温回路调节完成"
    }, {
      time: "09:58:33",
      title: "测舱2真空度瞬时抖动",
      desc: "抽气曲线已回稳"
    }];
    const chamberCards = computed(() => chamberDefinitions.map(definition => {
      const values = chamberSeries.value[definition.key];
      const value = values[values.length - 1];
      const previous = values[values.length - 2] ?? value;
      const delta = value - previous;
      return {
        ...definition,
        value,
        delta,
        state: Math.abs(delta) < 0.03 ? "稳定" : "微调"
      };
    }));
    const energyHighlights = computed(() => [{
      label: "累计用电",
      value: formatValue(energyState.value.power, 1),
      unit: "kWh",
      color: "#63f7ff"
    }, {
      label: "累计用水",
      value: formatValue(energyState.value.water, 1),
      unit: "m³",
      color: "#8ec5ff"
    }, {
      label: "压缩空气",
      value: formatValue(energyState.value.air, 1),
      unit: "Nm³",
      color: "#7effc1"
    }]);
    const auxiliaryMetrics = computed(() => [{
      label: "主舱回水温度",
      value: formatValue(energyState.value.mainReturnTemp, 1),
      unit: "℃"
    }, {
      label: "主舱回水流量",
      value: formatValue(energyState.value.mainReturnFlow, 1),
      unit: "L/min"
    }, {
      label: "主舱供气压力",
      value: formatValue(energyState.value.mainSupplyPressure, 2),
      unit: "MPa"
    }, {
      label: "轴舱回水温度",
      value: formatValue(energyState.value.shaftReturnTemp, 1),
      unit: "℃"
    }, {
      label: "轴舱回水流量",
      value: formatValue(energyState.value.shaftReturnFlow, 1),
      unit: "L/min"
    }, {
      label: "轴舱回水压力",
      value: formatValue(energyState.value.shaftReturnPressure, 2),
      unit: "MPa"
    }]);
    const systemTimes = computed(() => [{
      label: "系统运行总时长",
      value: formatDuration(runtimeState.value.totalSeconds),
      note: "全局稳定"
    }, {
      label: "当前轴气时长",
      value: formatDuration(runtimeState.value.axisGasSeconds),
      note: "本轮累计"
    }]);
    const vacuumTrendOption = computed(() => ({
      animation: false,
      backgroundColor: "transparent",
      legend: {
        show: false
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "rgba(8, 17, 32, 0.92)",
        borderColor: "rgba(111, 191, 255, 0.2)",
        textStyle: {
          color: "#eef7ff",
          fontSize: 11
        },
        formatter: params => params.map((item, index) => {
          const prefix = index === 0 ? `${item.axisValue}<br/>` : "";
          return `${prefix}${item.marker}${item.seriesName}：${formatValue(item.data, 3)} Pa`;
        }).join("<br/>")
      },
      grid: {
        top: 10,
        right: 10,
        bottom: 20,
        left: 28,
        containLabel: true
      },
      xAxis: {
        type: "category",
        data: timeline.value,
        boundaryGap: false,
        axisLine: {
          lineStyle: {
            color: "rgba(132, 181, 255, 0.12)"
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "rgba(190, 217, 245, 0.48)",
          fontSize: 10,
          interval: chartLabelInterval,
          margin: 10
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: "value",
        min: 0.2,
        max: 1.2,
        splitNumber: 3,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "rgba(190, 217, 245, 0.5)",
          fontSize: 10,
          formatter: value => value.toFixed(1)
        },
        splitLine: {
          lineStyle: {
            color: "rgba(132, 181, 255, 0.08)",
            type: "dashed"
          }
        }
      },
      series: chamberDefinitions.map(definition => ({
        name: definition.name,
        type: "line",
        smooth: true,
        symbol: "none",
        data: chamberSeries.value[definition.key],
        lineStyle: {
          width: 1.6,
          color: definition.color
        },
        areaStyle: {
          opacity: 0.08,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: definition.softColor
          }, {
            offset: 1,
            color: "rgba(0, 0, 0, 0)"
          }])
        }
      }))
    }));
    let runtimeTimer = null;
    let simulationTimer = null;
    onMounted(() => {
      runtimeTimer = setInterval(() => {
        runtimeState.value.totalSeconds += 1;
        runtimeState.value.axisGasSeconds += 1;
      }, 1000);
      simulationTimer = setInterval(() => {
        tickSimulation();
      }, simulationStepSeconds * 1000);
    });
    onUnmounted(() => {
      if (runtimeTimer) {
        clearInterval(runtimeTimer);
      }
      if (simulationTimer) {
        clearInterval(simulationTimer);
      }
    });
    function tickSimulation() {
      const nextSeries = {};
      chamberDefinitions.forEach(definition => {
        const values = chamberSeries.value[definition.key];
        const current = values[values.length - 1];
        const drift = (Math.random() - 0.5) * definition.variance;
        const nextValue = clamp(current + drift, definition.min, definition.max);
        nextSeries[definition.key] = [...values.slice(1), Number(nextValue.toFixed(3))];
      });
      chamberSeries.value = nextSeries;
      timeline.value = [...timeline.value.slice(1), formatClock(new Date())];
      energyState.value = {
        power: Number((energyState.value.power + 1.2 + Math.random() * 0.4).toFixed(1)),
        water: Number((energyState.value.water + 0.6 + Math.random() * 0.3).toFixed(1)),
        air: Number((energyState.value.air + 0.4 + Math.random() * 0.2).toFixed(1)),
        mainReturnTemp: nextFloat(energyState.value.mainReturnTemp, 18.6, 0.16, 18.1, 19.3),
        mainReturnFlow: nextFloat(energyState.value.mainReturnFlow, 42.5, 0.22, 41.2, 43.8),
        mainSupplyPressure: nextFloat(energyState.value.mainSupplyPressure, 0.62, 0.012, 0.58, 0.67),
        shaftReturnTemp: nextFloat(energyState.value.shaftReturnTemp, 20.1, 0.18, 19.4, 20.8),
        shaftReturnFlow: nextFloat(energyState.value.shaftReturnFlow, 39.4, 0.26, 38.1, 40.9),
        shaftReturnPressure: nextFloat(energyState.value.shaftReturnPressure, 0.58, 0.012, 0.54, 0.63)
      };
    }
    function createInitialSeries() {
      const series = {};
      chamberDefinitions.forEach(definition => {
        const values = [];
        let current = definition.base;
        for (let index = 0; index < chartPointCount; index += 1) {
          current = clamp(current + (Math.random() - 0.5) * definition.variance, definition.min, definition.max);
          values.push(Number(current.toFixed(3)));
        }
        series[definition.key] = values;
      });
      return series;
    }
    function createInitialTimeline(count, stepSeconds) {
      const now = Date.now();
      return Array.from({
        length: count
      }, (_, index) => {
        const offset = (count - index - 1) * stepSeconds * 1000;
        return formatClock(new Date(now - offset));
      });
    }
    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }
    function nextFloat(current, baseline, step, min, max) {
      const driftToBaseline = (baseline - current) * 0.08;
      const noise = (Math.random() - 0.5) * step;
      return Number(clamp(current + driftToBaseline + noise, min, max).toFixed(2));
    }
    function formatClock(date) {
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      const second = String(date.getSeconds()).padStart(2, "0");
      return `${hour}:${minute}:${second}`;
    }
    function formatDuration(totalSeconds) {
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, "0");
      const seconds = String(totalSeconds % 60).padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    function formatValue(value, digits) {
      return Number(value).toFixed(digits);
    }
    function formatDelta(delta) {
      const prefix = delta >= 0 ? "+" : "";
      return `较上次 ${prefix}${formatValue(delta, 3)} Pa`;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Head, {
        title: "电推进真空环境模拟系统"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("aside", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chamberCards.value, card => {
        return _openBlock(), _createElementBlock("article", {
          key: card.key,
          class: "vacuum-metric",
          style: _normalizeStyle({
            '--accent': card.color,
            '--accent-soft': card.softColor
          })
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(card.name), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(card.state), 1)]), _createElementVNode("div", _hoisted_10, [_createTextVNode(_toDisplayString(formatValue(card.value, 3)) + " ", 1), _hoisted_11]), _createElementVNode("div", _hoisted_12, _toDisplayString(formatDelta(card.delta)), 1)], 4);
      }), 128))]), _createElementVNode("div", _hoisted_13, [_createVNode(Map, {
        option: vacuumTrendOption.value
      }, null, 8, ["option"])])]), _createElementVNode("section", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(energyHighlights.value, metric => {
        return _openBlock(), _createElementBlock("article", {
          key: metric.label,
          class: "energy-highlight",
          style: _normalizeStyle({
            '--accent': metric.color
          })
        }, [_createElementVNode("span", _hoisted_17, _toDisplayString(metric.label), 1), _createElementVNode("strong", _hoisted_18, _toDisplayString(metric.value), 1), _createElementVNode("span", _hoisted_19, _toDisplayString(metric.unit), 1)], 4);
      }), 128))]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auxiliaryMetrics.value, metric => {
        return _openBlock(), _createElementBlock("article", {
          key: metric.label,
          class: "aux-metric"
        }, [_createElementVNode("span", _hoisted_21, _toDisplayString(metric.label), 1), _createElementVNode("div", _hoisted_22, [_createTextVNode(_toDisplayString(metric.value) + " ", 1), _createElementVNode("span", null, _toDisplayString(metric.unit), 1)])]);
      }), 128))])]), _createElementVNode("section", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemTimes.value, item => {
        return _openBlock(), _createElementBlock("article", {
          key: item.label,
          class: "runtime-row"
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(item.note), 1)]), _createElementVNode("strong", _hoisted_29, _toDisplayString(item.value), 1)]);
      }), 128))])])]), _createElementVNode("section", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("section", _hoisted_32, [_createElementVNode("img", {
        src: _unref(modelImage),
        alt: "真空环境模型",
        class: "model-stage__image"
      }, null, 8, _hoisted_33)]), _createElementVNode("nav", _hoisted_34, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(stageMenuItems, (item, index) => {
        return _createElementVNode("article", {
          key: item.code,
          class: _normalizeClass(["stage-menu__item", {
            'is-active': index === 0
          }]),
          "aria-current": index === 0 ? 'page' : undefined
        }, [_createElementVNode("span", _hoisted_36, _toDisplayString(item.code), 1), _createElementVNode("strong", _hoisted_37, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_38, _toDisplayString(item.caption), 1)], 10, _hoisted_35);
      }), 64))])])]), _createElementVNode("aside", _hoisted_39, [_createElementVNode("section", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("video", {
        class: "video-shell__player",
        src: _unref(chamberVideo),
        autoplay: "",
        muted: "",
        loop: "",
        playsinline: ""
      }, null, 8, _hoisted_43)])]), _createElementVNode("section", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceStatuses, item => {
        return _createElementVNode("article", {
          key: item.name,
          class: "status-row"
        }, [_createElementVNode("div", _hoisted_47, [_createElementVNode("span", _hoisted_48, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(item.description), 1)]), _hoisted_50]);
      }), 64))])]), _createElementVNode("section", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(processedAlarms, item => {
        return _createElementVNode("article", {
          key: item.time,
          class: "alarm-row"
        }, [_createElementVNode("div", _hoisted_54, _toDisplayString(item.time), 1), _createElementVNode("div", _hoisted_55, [_createElementVNode("strong", _hoisted_56, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_57, _toDisplayString(item.desc), 1)]), _hoisted_58]);
      }), 64))])])])])]);
    };
  }
};